import v4 from 'uuid/v4';
import makePlainAction from '../../../../creators/actions/makePlainAction';
import destroyAlert from '../destroyAlert';
/**
 * Thunk that creates an alert. Action has the type `CREATE_ALERT`.
 *
 * @param {Object} options The options for the action
 * @param {string} options.message The body of the alert.
 * @param {string} options.id A unique id for the alert.
 * @param {string} options.type A key to indicate the style of the alert.
 * @param {Number} options.time Milliseconds until a destroyAlert action should
 *                              be fired.
 * @return {Function} The action thunk
 *
 * @public
 * @author Connor Taylor
 * @example
 * dispatch(createAlert({ message: `You done goofed` }));
 */

var createAlert = function createAlert(_ref) {
  var message = _ref.message,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? v4() : _ref$id,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "success" : _ref$type,
      _ref$time = _ref.time,
      time = _ref$time === void 0 ? 3000 : _ref$time;
  var create = makePlainAction({
    model: "alert",
    verb: "create"
  });
  return function (dispatch) {
    setTimeout(function () {
      return dispatch(destroyAlert({
        id: id
      }));
    }, time);
    dispatch(create({
      data: {
        id: id,
        message: message,
        type: type
      }
    }));
  };
};
/** @component */


export default createAlert;